(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'application',
            url: '/password',
            data: {
                authorities: [],
                pageTitle: 'Resetowanie hasła - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
